export * from './person-scoped-data-table';
